module.exports = __webpack_public_path__ + "img/gamesdk2.86266e0.png";